export const drawingConstants = {
    ANNOTATION_TYPE: {
        'rect': {
            name: 'Rectangle',
            typeName: 'rect',
            shape: 'rect',
            icon: 'flaticon-layouts'
        },
        'circle': {
            name: 'Circle',
            typeName: 'circle',
            shape: 'circle',
            icon: 'flaticon-ui'
        },
        'textbox': {
            name: 'Textbox',
            typeName: 'textbox',
            shape: 'textbox',
            icon: 'flaticon-test-box'
        },
        'path': {
            name: 'Freehand',
            typeName: 'path',
            shape: 'path',
            icon: 'flaticon-direction'
        },
        'arrow': {
            name: 'Arrow',
            typeName: 'arrow',
            shape: 'arrow',
            icon: 'flaticon-arrows'
        },
        'commentStamp': {
            name: 'Comment',
            typeName: 'commentStamp',
            shape: 'image',
            icon: 'flaticon-comment'
        },
        'pinPointer': {
            name: 'Pin',
            typeName: 'pinPointer',
            shape: 'pinPointer',
            icon: 'flaticon-pinPointer'
        },        
        'highlight': {
            name: 'Highlight',
            typeName: 'highlight',
            shape: 'highlight',
            icon: 'flaticon-highlight'
        },
        'strikeOut': {
            name: 'strike',
            typeName: 'strikeOut',
            shape: 'rect',
            icon: 'flaticon-layouts'
        },
        'textHighlight': {
            name: 'Text Highlight',
            typeName: 'textHighlight',
            shape: 'textHighlight',
            icon: 'flaticon-textHighlight'
        },
    }
};
